import { ApiHelper, axiosInstance } from "../../utils/ApiHelper"
import { push, goBack } from "react-router-redux"
import { SubmissionError, change } from "redux-form"
import { clearFilters } from "../../transactions/actions"
import { message, Button, notification } from "antd"

const plaidOptions = {
  env: process.env.REACT_APP_PLAID_ENV,
  apiVersion: "v2",
  clientName: "Everlance",
  key: process.env.REACT_APP_PLAID_PUBLIC_KEY,
  product: ["transactions"],
  // token: json.data.public_token,
  onLoad: function() {
    // Optional, called when Link loads
  },

  onExit: function(err, metadata) {
    // The user exited the Link flow.
    if (err != null) {
      // The user encountered a Plaid API error prior
      // to exiting.
    }
    // metadata contains information about the institution
    // that the user selected and the most recent API request
    // IDs. Storing this information is helpful for support.
  }
}

export function limitPlaidAttempts(linkHandler) {
  return (dispatch, getState) => {
    const { attempts } = getState().account.bankCard

    if (attempts >= 10) {
      notification.open({
        message: "Bank connection attempt limit exceeded",
        description:
          "Too many failed attempts to sign in. Please try again in the next hour."
      })

      linkHandler && linkHandler.exit({ force: true })

      setTimeout(() => {
        dispatch({
          type: `RESET_PLAID_ATTEMPTS`
        })
      }, 10 * 60 * 1000)

      return
    }
  }
}

export function addBank() {
  return (dispatch, getState) => {
    const { isPremium } = getState().models.user

    // Initialize Link with the `token` parameter
    // set to the generated public_token for the Item
    var linkHandler = window.Plaid.create({
      ...plaidOptions,
      webhook: process.env.REACT_APP_PLAID_WEBHOOK,
      onSuccess: function(public_token, metadata) {
        dispatch(handleOnSuccess(public_token, metadata))

        // You do not need to repeat the /item/public_token/exchange
        // process when a user uses Link in update mode.
        // The Item's access_token has not changed.
      },
      onEvent: function(eventName, metadata) {
        dispatch({
          type: `PLAID_${eventName}`,
          metadata
        })
        if (eventName == "ERROR")
          return dispatch(limitPlaidAttempts(linkHandler))

        if (eventName == "SELECT_INSTITUTION" && !isPremium) {
          linkHandler.exit({ force: true })
          dispatch({
            type: "SHOW_MODAL",
            modalType: "UNLOCK_PREMIUM_MODAL",
            modalProps: {}
          })
        }
        // Optionally capture Link flow events, streamed through
        // this callback as your users connect an Item to Plaid.
        // For example:
        // eventName = "TRANSITION_VIEW"
        // metadata  = {
        //   link_session_id: "123-abc",
        //   mfa_type:        "questions",
        //   timestamp:       "2017-09-14T14:42:19.350Z",
        //   view_name:       "MFA",
        // }
      }
    })

    linkHandler.open()
  }
}

export function handleOnSuccess(public_token, metadata) {
  return dispatch => {
    // Open up PlaidImportHistoryModal
    dispatch({ type: "SET_PLAID_LINK_DATA", public_token, metadata })

    dispatch({
      type: "SHOW_MODAL",
      modalType: "PLAID_IMPORT_HISTORY_MODAL",
      modalProps: {
        // public_token,
        // metadata
      }
    })
  }
}

export function createInstitutionUser() {
  return (dispatch, getState) => {
    const {
      public_token,
      metadata,
      import_history
    } = getState().account.bankCard
    dispatch({
      type: "CREATE_INSTITUTION_USER_REQUEST",
      public_token,
      metadata,
      import_history
    })
    return ApiHelper.createInstitutionUser(
      public_token,
      metadata,
      import_history
    ).then(json => {
      dispatch({ type: "CREATE_INSTITUTION_USER_SUCCESS", payload: json.data })

      // dispatch(getTransactions(json.data.transactions))
      // dispatch(clearFilters())

      dispatch({
        type: "SHOW_MODAL",
        modalType: "BANK_CARD_SYNC_MODAL",
        modalProps: {
          buttonText: "Next",
          title: `Select Accounts`,
          message: `Which accounts do you want to sync?`,
          // public_token, metadata, import_history,
          tokenId: json.data.institution_user.token_id
        }
      })
    })
  }
}

// triggered from PlaidImportHistoryModal:
export function setPlaidImportHistory(import_history) {
  return dispatch => {
    dispatch({ type: "SET_PLAID_IMPORT_HISTORY", import_history })

    dispatch(createInstitutionUser())
  }
}

export function setUnclassifiedTxnCount(count) {
  return { type: "SET_UNCLASSIFIED_TXN_COUNT", count }
}

export function toggle(token_id, excluded) {
  return dispatch => {
    dispatch({
      type: "TOGGLE_INSTITUTION_ACCOUNT_REQUEST",
      payload: { token_id, excluded }
    })
    return ApiHelper.updateInstitutionAccount(token_id, excluded).then(json => {
      dispatch({
        type: "TOGGLE_INSTITUTION_ACCOUNT_SUCCESS",
        payload: json.data
      })

      dispatch(
        setUnclassifiedTxnCount(
          json.data.total_uncategorized_transactions_count
        )
      )

      // dispatch(getTransactions(json.data.transactions))
      dispatch(clearFilters())
    })
  }
}

export function unlink(token_id) {
  return dispatch => {
    dispatch({ type: "UNLINK_INSTITUTION_USER_REQUEST", token_id })
    return ApiHelper.unlinkInstitutionUser(token_id).then(json => {
      dispatch({
        type: "UNLINK_INSTITUTION_USER_SUCCESS",
        payload: json.data,
        token_id
      })
    })
  }
}

export function updateLogin(token_id) {
  return dispatch => {
    dispatch({ type: "UPDATE_INSTITUTION_LOGIN_REQUEST", token_id })
    return ApiHelper.updateLogin(token_id).then(json => {
      dispatch({
        type: "UPDATE_INSTITUTION_LOGIN_SUCCESS",
        payload: json.data,
        token_id
      })

      // Initialize Link with the `token` parameter
      // set to the generated public_token for the Item
      var linkHandler = window.Plaid.create({
        ...plaidOptions,
        token: json.data.public_token,
        onSuccess: function(public_token, metadata) {
          // You do not need to repeat the /item/public_token/exchange
          // process when a user uses Link in update mode.
          // The Item's access_token has not changed.
        }
      })

      linkHandler.open()
    })
  }
}

export function refresh() {
  return dispatch => {
    dispatch({ type: "REFRESH_INSTITUTIONS_REQUEST" })
    return ApiHelper.refreshInstitution().then(json => {
      dispatch({ type: "REFRESH_INSTITUTIONS_SUCCESS", payload: json.data })
      notification.open({
        message: "Transactions are updating...",
        description:
          "It may take up to 2 business days depending on your bank and pending status, we'll post them when they're completed"
      })
    })
  }
}

export function importTxnStatus() {
  return dispatch => {
    dispatch({ type: "IMPORT_TXN_STATUS_REQUEST" })

    return ApiHelper.importTxnStatus().then(({ data }) => {
      dispatch({ type: "IMPORT_TXN_STATUS_SUCCESS", payload: data })
      const isFinished = data.finished

      if (!isFinished)
        setTimeout(() => {
          dispatch(importTxnStatus())
        }, 3000)

      if (isFinished) {
        // dispatch(getTransactions(json.data.transactions))

        dispatch(
          setUnclassifiedTxnCount(data.total_uncategorized_transactions_count)
        )
        dispatch(clearFilters())
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/account/bank-card/actions.js